<template>
    <el-dialog v-dialogDrag class="dialog" width="450px"
               :visible.sync="dialogVisible" v-loading="dialoading"
               append-to-body
               top="10vh" @close="close" center>
        <div slot="title">
            <div class="dialog_title">
                导入excel
            </div>
        </div>

        <div class="dialog_body">
            <el-upload class="upload-demo"
                       ref="uploads"
                       drag
                       with-credentials
                       :limit="1"
                       :file-list="fileList"
                       accept=".xls, .xlsx"
                       :auto-upload="false"
                       :on-exceed="onExceed"
                       :on-change="onChange"
                       :on-success="onSuccess"
                       :action="fileUrl">
                <i class="el-icon-upload"></i>
                <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                <div class="el-upload__tip" slot="tip">只能上传 EXCEL 文件</div>
            </el-upload>
            <div style="text-align: center;padding: 10px 0px 20px 0px">
                <el-button type="info" @click="close">取 消</el-button>
                <el-button type="success" @click="downBoard">模板下载</el-button>
                <el-button type="primary" @click="importData">开始导入数据</el-button>
            </div>
        </div>
    </el-dialog>
</template>

<script>
    var XLSX = require('xlsx')

    export default {
        name: "import",
        props: ['importUrl','mouduleUrl'],
        data() {
            return {
                fileUrl:window.host.ProjectUrl+ this.importUrl,
                outUrl:window.host.ProjectUrl+ this.mouduleUrl,
                dialoading: false,
                dialogVisible: true,
                fileList: [],
            };
        },
        mounted() {
        },
        methods: {
            onChange(file, fileList) {
                this.fileList = fileList;
            },
            onSuccess(res, file){
                if(res.infoCode === "0"){
                    this.$message({
                        message: "导入表格数据成功",
                        showClose: true,
                        type: "success"
                    });
                    this.fileList = [file]
                    this.$emit('refresh')
                    this.close()
                }else{
                    this.$message.error(res.infoDescribe);
                }
            },
            onExceed() {
                this.$message.error("只能导入一个文件!");
            },
            downBoard(){
                window.open(this.outUrl)
            },
            importData() {
                if(this.fileList.length<1){
                    this.$message.error("请先上传一个文件！");
                }else{
                    this.$refs.uploads.submit();
                }
            },
            close() {
                this.$emit('closeDialog', this.dialogVisible)
            },
        }
    }
</script>

